export default function AtlasToolbarIconButton({
  onClick,
  title,
  active = false,
  disabled = false,
  children,
  className = "",
  "aria-expanded": ariaExpanded,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      aria-expanded={ariaExpanded}
      className={[
        "rounded p-2 transition-colors disabled:opacity-50",
        active ? "bg-gray-100 text-gray-800" : "text-gray-600 hover:bg-gray-50",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </button>
  );
}
